import { getOrganizationIssueTypes } from './actions'
import { getOrganizationStatusGroups } from '../statuses/actions'
import { getOrganizationLabelGroups } from '../labels/actions'

export default async function issueTypeLoader() {
  const [issueTypes, statusGroups, labelGroups] = await Promise.all([
    getOrganizationIssueTypes({ view: 'organization', projectId: undefined }),
    getOrganizationStatusGroups({ view: 'organization', projectId: undefined }),
    getOrganizationLabelGroups({ view: 'organization', projectId: undefined }),
  ])

  return { issueTypes, statusGroups, labelGroups }
}
